/**
 * Nutrition Facts Modal
 * Opens a modal with nutrition/ingredient data for each flavor.
 * Flavor cards trigger it via [data-bab-nutrition-link].
 */
(function initMealNutrition() {
  'use strict';
  if (window.__babDisposeNutrition) window.__babDisposeNutrition();
  var lifecycle = new AbortController();
  window.__babDisposeNutrition = function () {
    if (modal && isTrapped) closeModal();
    lifecycle.abort();
  };
  if (window.Shopify && window.Shopify.designMode && !window.__babDisposeNutritionEditor) {
    window.__babDisposeNutritionEditor = true;
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('#build-a-box')) initMealNutrition();
    });
  }


  var modal = document.querySelector('[data-nutrition-modal]');
  if (!modal) return;
  // Custom labels replace the original nutrition panel for that product.
  modal.querySelectorAll('[data-nutrition-custom]').forEach(function (custom) {
    modal.querySelectorAll('[data-nutrition-panel]').forEach(function (panel) {
      if (panel !== custom && !panel.hasAttribute('data-nutrition-custom') && panel.dataset.nutritionPanel === custom.dataset.nutritionPanel) panel.remove();
    });
  });
  var titleEl = modal.querySelector('[data-nutrition-title]');
  var panels = modal.querySelectorAll('[data-nutrition-panel]');
  var handles = Array.from(panels).map(function (panel) { return panel.dataset.nutritionPanel; });
  var cards = Array.from(document.querySelectorAll('[data-bab-flavor]'));
  var FLAVOR_ORDER = cards.length ? cards.map(function (card) { return card.dataset.flavorHandle; }).filter(function (handle) { return handles.indexOf(handle) !== -1; }) : handles;
  FLAVOR_ORDER = Array.from(new Set(FLAVOR_ORDER));
  if (!FLAVOR_ORDER.length) return;
  var closeBtn = modal.querySelector('.bab-nutrition-modal__close');
  var currentIndex = 0;
  var returnFocusEl = null;
  var isTrapped = false;

  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]),' +
    ' select:not([disabled]), textarea:not([disabled]), iframe, object, embed,' +
    ' [contenteditable="true"], [tabindex]:not([tabindex^="-"])';

  /* ---- Helpers ---- */

  function getFlavorIndex(handle) {
    var idx = FLAVOR_ORDER.indexOf(handle);
    return idx;
  }

  function showPanel(index) {
    if (index < 0) return;
    currentIndex = index;
    var handle = FLAVOR_ORDER[currentIndex];

    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      if (panel.getAttribute('data-nutrition-panel') === handle) {
        panel.classList.add('is-active');
        titleEl.textContent = panel.getAttribute('data-nutrition-label').toUpperCase();
      } else {
        panel.classList.remove('is-active');
      }
    }
  }

  /* ---- Focus management ---- */

  // Can this element actually take focus right now? A display:none subtree has
  // no box, so it reports zero size and no client rects.
  function isFocusableNow(el) {
    return !!(el && el.nodeType === 1 && typeof el.focus === 'function' &&
      document.contains(el) && !el.disabled &&
      (el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0));
  }

  function getFocusableIn(container) {
    var nodes = container.querySelectorAll(FOCUSABLE);
    var visible = [];
    for (var i = 0; i < nodes.length; i++) {
      if (isFocusableNow(nodes[i])) visible.push(nodes[i]);
    }
    return visible;
  }

  function onTrapKeydown(e) {
    if (e.key !== 'Tab' || !isTrapped) return;
    var focusable = getFocusableIn(modal);
    if (!focusable.length) {
      e.preventDefault();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;
    var inside = modal.contains(active);

    if (e.shiftKey) {
      if (!inside || active === first) {
        e.preventDefault();
        last.focus();
      }
    } else if (!inside || active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* Where focus goes when the remembered opener is gone by the time the dialog
     closes (the flavor card it lived on can be re-rendered while the modal is
     open). Land on any nutrition trigger that is actually on screen. */
  function fallbackFocusTarget() {
    var candidates = document.querySelectorAll('[data-bab-nutrition-link], [data-open-nutrition-modal]');
    for (var i = 0; i < candidates.length; i++) {
      if (isFocusableNow(candidates[i])) return candidates[i];
    }
    return null;
  }

  function captureFocus() {
    var opener = document.activeElement;
    // <body> is not a return target (clicking a button in Safari leaves focus
    // there), and neither is anything already inside the dialog.
    returnFocusEl = (opener && opener !== document.body && opener.closest &&
      !modal.contains(opener)) ? opener : null;
    isTrapped = true;
    // Re-adding the same listener reference is a no-op, so repeated opens
    // cannot stack duplicate handlers.
    document.addEventListener('keydown', onTrapKeydown, { capture: true, signal: lifecycle.signal });
    var target = isFocusableNow(closeBtn) ? closeBtn : getFocusableIn(modal)[0];
    if (target) target.focus();
  }

  function releaseFocus() {
    // closeModal also runs on a stray Escape with nothing open; don't move
    // focus in that case.
    if (!isTrapped) return;
    document.removeEventListener('keydown', onTrapKeydown, true);
    isTrapped = false;
    var returnTo = returnFocusEl;
    returnFocusEl = null;
    if (!isFocusableNow(returnTo)) returnTo = fallbackFocusTarget();
    if (returnTo) {
      try { returnTo.focus(); } catch (err) { /* element became unfocusable */ }
    }
  }

  function openModal(handle) {
    if (getFlavorIndex(handle) < 0) return;
    showPanel(getFlavorIndex(handle));
    modal.style.display = '';
    document.body.style.overflow = 'hidden';
    captureFocus();
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    releaseFocus();
  }

  function prevFlavor() {
    var next = (currentIndex - 1 + FLAVOR_ORDER.length) % FLAVOR_ORDER.length;
    showPanel(next);
  }

  function nextFlavor() {
    var next = (currentIndex + 1) % FLAVOR_ORDER.length;
    showPanel(next);
  }

  /* ---- Event Listeners ---- */

  // Open from flavor card nutrition links or any [data-bab-nutrition-link] element
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-bab-nutrition-link]');
    if (!link) return;

    e.preventDefault();
    var card = link.closest('[data-flavor-handle]');
    var handle = card ? card.getAttribute('data-flavor-handle') : FLAVOR_ORDER[0];
    openModal(handle);
  }, { signal: lifecycle.signal });

  // Open from generic modal trigger buttons (e.g. ingredient carousel CTA)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-open-nutrition-modal]');
    if (!btn) return;

    e.preventDefault();
    openModal(FLAVOR_ORDER[0]);
  }, { signal: lifecycle.signal });

  // Close buttons and overlay
  var closeTriggers = modal.querySelectorAll('[data-nutrition-close]');
  for (var i = 0; i < closeTriggers.length; i++) {
    closeTriggers[i].addEventListener('click', closeModal);
  }

  // Prev / Next arrows
  var prevBtn = modal.querySelector('[data-nutrition-prev]');
  var nextBtn = modal.querySelector('[data-nutrition-next]');
  if (prevBtn) prevBtn.addEventListener('click', prevFlavor);
  if (nextBtn) nextBtn.addEventListener('click', nextFlavor);

  // Escape key closes modal
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.style.display !== 'none') {
      closeModal();
    }
  }, { signal: lifecycle.signal });
})();
